import { TaskType as GqlTaskType } from '@willow/graphql-iso/src/app/backend';
import { TaskType } from '@willow/types-iso';

import { convertEnumToGqlEnum, convertGqlEnumToEnum } from '../gql';

export const gqlToIsoTaskType = convertGqlEnumToEnum<typeof GqlTaskType, TaskType>(GqlTaskType);
export const isoToGqlTaskType = convertEnumToGqlEnum<typeof GqlTaskType, TaskType>(GqlTaskType);
